var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_23556_319570)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.1029 0L9.90105 1.26606L3.90105 4.73395L1.69922 6V18L3.90105 19.2661L9.9561 22.7339L12.1579 24L14.3598 22.7339L20.3047 19.2661L22.5066 18V6L20.3047 4.73395L14.3047 1.26606L12.1029 0ZM6.10289 15.4679V8.53211L12.1029 5.06422L18.1029 8.53211V15.4679L12.1029 18.9358L6.10289 15.4679Z",
    fill: "#2A5ADA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_23556_319570"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20.8073,
    height: 24,
    fill: "white",
    transform: "translate(1.69922)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink);
export default __webpack_public_path__ + "static/media/LINK.3a07c626a2cf556aaf1f917ce6d454e2.svg";
export { ForwardRef as ReactComponent };